import { ConstraintConfigType } from "types/ConstraintsTypes";
import { ConstraintContent } from "../ConstraintContent";

type TopQualityContentProps = {
  configData: ConstraintConfigType;
};

export function TopQualityContent({ configData }: TopQualityContentProps) {
  return (
    <ConstraintContent
      configData={configData}
      dataKey="top_quality"
    />
  );
}
